import type { Bonus, EliteGuide, FaqItem, Testimonial, Tome } from "../types/content";

export const CHECKOUT_URL = "#oferta"; // PEGAR AQUÍ EL ENLACE ÚNICO DE CHECKOUT
export const MOCKUP_URL = "https://cdn.magicpatterns.com/uploads/ofQhhYZqChi3qASpP4fWKs/Mega_pack_atletismo_resuelto.png";

export const testimonials: Testimonial[] = [
  {
    quote: "Organicé todo mi año de atletismo en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.",
    name: "Guillermo M.",
    location: "Formosa",
    role: "ENTRENADOR DE ATLETISMO EN CLUB",
  },
  {
    quote: "Las progresiones técnicas por disciplina cambiaron todo. Mis atletas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.",
    name: "Martín J.",
    location: "Buenos Aires",
    role: "PROFE DE ATLETISMO EN CENTRO DEPORTIVO",
  },
  {
    quote: "Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado.",
    name: "Julián A.",
    location: "Córdoba",
    role: "ENTRENADOR DE ATLETISMO GRUPAL E INDIVIDUAL",
  },
];

export const problems = [
  "Llegás a la clase sin saber exactamente qué ejercicio vas a dar hoy",
  "Tus atletas no progresan porque no tenés una secuencia clara de nivel a nivel",
  "El 40% de tus atletas abandona antes de los 3 meses y no sabés cómo prevenirlo",
  "Siempre los mismos ejercicios de siempre porque no tenés más material listo",
  "No podés justificar un aumento de precio porque no tenés un sistema profesional visible",
  "Correcciones técnicas improvisadas, sin un método claro que te respalde",
  "Atletas de distintos niveles juntos y la clase se convierte en un caos",
  "Fin de mes y los atletas se van sin avisar porque la comunicación es inconsistente",
];

export const areas = [
  "Fundamentos", "Velocidad", "Resistencia", "Saltos", "Lanzamientos", "Planificación",
  "Técnica", "Corrección", "Seguridad", "Evaluación", "Progresión", "Seguimiento",
];

export const levels = [
  { icon: "🟢", label: "Principiante", color: "text-[#27B36A]" },
  { icon: "🟡", label: "Intermedio", color: "text-[#F5B83D]" },
  { icon: "🔴", label: "Avanzado", color: "text-[#E3262E]" },
  { icon: "💼", label: "Planificación", color: "text-[#F5B83D]" },
  { icon: "📊", label: "Evaluación", color: "text-[#FFD66B]" },
  { icon: "🏟️", label: "Club y Escuela", color: "text-[#FFFFFF]" },
];

export const tomes: Tome[] = [
  {
    number: 1,
    eyebrow: "TEORÍA ESENCIAL",
    title: "Fundamentos del Atletismo",
    description: "El punto de partida para enseñar atletismo con criterio y seguridad.",
    details: [
      "Qué es el atletismo y sus disciplinas.",
      "Principios del entrenamiento aplicados al atletismo.",
      "Cómo organizar una sesión de entrenamiento.",
      "Metodología de iniciación deportiva.",
      "Cómo trabajar con grupos de distintos niveles.",
      "Atletismo en contexto de club vs. contexto escolar.",
      "Errores más frecuentes del entrenador principiante.",
      "Glosario técnico básico del atletismo.",
    ],
  },
  { number: 2, eyebrow: "15 CLASES LISTAS", title: "Velocidad y Relevos", description: "Progresiones técnicas completas para enseñar velocidad desde cero, con clases estructuradas, objetivos claros, ejercicios, variantes y correcciones." },
  { number: 3, eyebrow: "15 CLASES LISTAS", title: "Medio Fondo y Fondo", description: "Todo para enseñar resistencia con metodología clara y progresión real, adaptando las propuestas a diferentes niveles y objetivos." },
  { number: 4, eyebrow: "15 CLASES LISTAS", title: "Saltos", description: "Progresiones técnicas para enseñar los 4 saltos con seguridad y claridad, desde los fundamentos hasta la aplicación técnica." },
  { number: 5, eyebrow: "15 CLASES LISTAS", title: "Lanzamientos", description: "Todo para enseñar los 4 lanzamientos con técnica y progresión real, incluyendo ejercicios, correcciones y adaptaciones por nivel." },
  { number: 6, eyebrow: "PLANTILLAS INCLUIDAS", title: "Planificación y Evaluación", description: "Tu año entero de atletismo organizado con criterios claros para planificar, evaluar y hacer crecer a tus atletas." },
  {
    number: 7,
    eyebrow: "ATLETISMO INFANTIL Y JUVENIL",
    title: "Juegos, progresiones y clases por edades",
    description: "Juegos, progresiones y clases adaptadas por edades para enseñar atletismo de forma segura, dinámica y organizada desde la iniciación hasta la formación técnica.",
    details: [
      "Enseñanza del atletismo según la edad.", "Desarrollo motor y coordinación.", "Juegos de iniciación atlética.",
      "Velocidad en edades tempranas.", "Saltos adaptados.", "Lanzamientos adaptados.", "Resistencia sin sobrecargar.",
      "Clases para grupos heterogéneos.", "Progresiones hacia la técnica formal.", "Motivación y permanencia.",
      "Organización de clases escolares.", "Organización de clases de club.", "Comunicación con familias.",
      "Evaluación por etapas.", "Plan anual de atletismo infantil y juvenil.",
    ],
  },
];

export const everyTomeIncludes = [
  "Planificación lista para usar desde el primer día.",
  "Clases con objetivo, desarrollo y cierre.",
  "Indicaciones técnicas listas para usar en clase.",
  "Variaciones Nivel 1, Nivel 2 y Nivel 3 por ejercicio.",
  "Checklist pre y durante la clase.",
  "Planillas de seguimiento del atleta.",
  "Adaptaciones para grupos heterogéneos.",
  "100% adaptado a la realidad del entrenador de atletismo argentino.",
];

export const bonuses: Bonus[] = [
  {
    number: 1,
    title: "Banco de Ejercicios Ilustrado",
    value: "$12.000",
    description: "+100 ejercicios categorizados listos para usar en clase.",
    details: [
      "+100 ejercicios categorizados por disciplina.", "Descripción clara de cada ejercicio.", "Objetivo específico de cada ejercicio.",
      "Variantes por nivel de dificultad.", "Formato visual e imprimible.", "Organizado por velocidad, resistencia, saltos y lanzamientos.",
    ],
  },
  { number: 2, title: "Planillas de Seguimiento del Atleta", value: "$10.000", description: "Sistema completo para registrar el progreso de cada atleta." },
  { number: 3, title: "Calendario de Temporada", value: "$9.000", description: "Tu año competitivo organizado visualmente de principio a fin." },
  { number: 4, title: "Fichas Técnicas Imprimibles por Disciplina", value: "$10.000", description: "Una ficha por disciplina para tener en el bolsillo durante la clase." },
  { number: 5, title: "Guía de Entradas en Calor Específicas", value: "$9.000", description: "Entrada en calor lista para cada disciplina, sin pensar ni improvisar." },
];

export const eliteGuides: EliteGuide[] = [
  {
    number: 1,
    title: "Guía de Prevención y Recuperación en Atletismo",
    quote: "Todo para que tus atletas no se lesionen y vos actúes con criterio cuando algo pasa.",
    details: [
      "Lesiones frecuentes por disciplina identificadas y prevenidas.", "Protocolo de actuación inmediata claro y seguro.",
      "Ejercicios de fortalecimiento preventivo por disciplina.", "Criterios claros de derivación al kinesiólogo o médico.",
      "Sistema de recuperación para mantener al atleta activo cuando corresponda.",
    ],
  },
  {
    number: 2,
    title: "Sistema de Evaluación y Detección de Talentos",
    quote: "Para que cada atleta esté en la disciplina correcta y progrese al máximo de su potencial.",
    details: [
      "Protocolo completo de evaluación física por disciplina.", "Fichas de detección de talentos por edad y perfil.",
      "Criterios claros para orientar atletas a la disciplina ideal.", "Planillas de seguimiento avanzado con histórico.",
      "Sistema de marcas y evolución visible para atletas y padres.",
    ],
  },
];

export const faqs: FaqItem[] = [
  { question: "¿Cómo recibo el Atletismo Resuelto después de comprar?", answer: "Después de confirmar el pago, recibís el acceso digital en pocos minutos en el correo utilizado durante la compra. Podés descargar y consultar los materiales desde tu computadora o celular." },
  { question: "¿Sirve para profes con poca experiencia o solo para los avanzados?", answer: "Sirve para todos los niveles. El sistema empieza por los fundamentos y avanza hacia la técnica, la planificación, la evaluación y el trabajo con atletas de distintos niveles." },
  { question: "¿Es editable? ¿Puedo modificarlo?", answer: "Sí. Los materiales y planillas están pensados para que puedas adaptarlos a tu espacio, tus grupos, tus horarios y tus objetivos." },
  { question: "¿Los 5 bonos están incluidos en la oferta?", answer: "Sí. Los 5 bonos estratégicos están incluidos sin costo extra dentro de la única oferta de Atletismo Resuelto™." },
  { question: "¿Las Guías Élite están incluidas?", answer: "Sí. Comprando hoy recibís sin cargo la Guía de Prevención y Recuperación en Atletismo y el Sistema de Evaluación y Detección de Talentos." },
  { question: "¿Sirve si doy clases individuales o solo para grupos?", answer: "Sirve para clases individuales, grupos reducidos, clubes, escuelas y grupos numerosos. Las variaciones por nivel permiten adaptar cada propuesta." },
  { question: "¿Sirve si tengo atletas de distintos niveles al mismo tiempo?", answer: "Sí. Cada propuesta incluye adaptaciones y variantes para Nivel 1, Nivel 2 y Nivel 3, lo que facilita trabajar con grupos heterogéneos." },
  { question: "¿Qué diferencia tiene con otros materiales de atletismo?", answer: "No es solamente teoría. Incluye clases completas, progresiones, indicaciones técnicas, planillas, fichas, planificación, evaluación y recursos listos para aplicar." },
  { question: "¿Tiene garantía real?", answer: "Sí. Tenés 7 días para revisar el material. Si no cumple tus expectativas, podés solicitar la devolución del 100%." },
];

export const withoutSystem = [
  "3–5 horas por semana planificando desde cero.", "Siempre los mismos ejercicios y atletas aburridos.",
  "Atletas que abandonan sin saber por qué.", "Sin progresión clara de nivel a nivel.",
  "Atleta con dificultad = pánico o improvisación.", "Niveles mezclados = caos de clase.",
  "Sin sistema de evaluación claro.", "Sin identidad profesional visible.",
];

export const withSystem = [
  "10 minutos por semana. El resto es entrenar.", "60+ clases distintas. Siempre hay algo nuevo.",
  "Sistema de progresión y retención visible.", "7 tomos con progresión anual.",
  "Protocolo técnico para actuar con confianza.", "Variaciones por nivel para que todos mejoren juntos.",
  "Fichas y tests listos para evaluar con criterio.", "Sistema que justifica cobrar lo que merecés.",
];
